export default __webpack_public_path__ + "static/media/sds.eebea86e.png";